import React, { useState } from "react";
import styles from "./ClickablePlot.module.css";

interface OpenSpacePoint {
  x: number;
  y: number;
  id: string;
  captureId: string;
  sequenceNumber?: number;
}

interface ClickablePlotProps {
  imageBase64: string;
  openspacePoints: OpenSpacePoint[];
  width: number;
  height: number;
  title: string;
  onPointClick: (point: OpenSpacePoint) => void;
}

export const ClickablePlot: React.FC<ClickablePlotProps> = ({
  imageBase64,
  openspacePoints,
  width,
  height,
  title,
  onPointClick,
}) => {
  const [hoveredPoint, setHoveredPoint] = useState<string | null>(null);
  const [showCircles, setShowCircles] = useState<boolean>(true);

  const handlePointClick = (point: OpenSpacePoint) => {
    onPointClick(point);
  };

  return (
    <div className={styles.plotContainer}>
      <div className={styles.plotHeader}>
        <h4 className={styles.plotTitle}>{title}</h4>
        <button
          className={styles.toggleButton}
          onClick={() => setShowCircles(!showCircles)}
        >
          {showCircles ? "Hide" : "Show"} Panorama Points
        </button>
      </div>
      <div className={styles.imageContainer}>
        <img
          src={`data:image/png;base64,${imageBase64}`}
          alt={title}
          className={styles.plotImage}
        />
        <svg
          className={styles.svgOverlay}
          viewBox={`0 0 ${width} ${height}`}
          preserveAspectRatio="none"
          style={{ aspectRatio: `${width} / ${height}` }}
        >
          {showCircles &&
            openspacePoints.map((point, index) => (
              <circle
                key={`${point.id}-${index}`}
                cx={point.x}
                cy={height - point.y} // Flip Y coordinate since SVG origin is top-left but matplotlib is bottom-left
                r="18"
                fill={
                  hoveredPoint === point.id
                    ? "#ffeb3b"
                    : "rgba(255, 235, 59, 0.8)"
                }
                stroke="#fff"
                strokeWidth="1.5"
                className={styles.clickableCircle}
                onMouseEnter={() => setHoveredPoint(point.id)}
                onMouseLeave={() => setHoveredPoint(null)}
                onClick={() => handlePointClick(point)}
                style={{ cursor: "pointer" }}
              />
            ))}
        </svg>
      </div>
    </div>
  );
};
